import { extraPrices } from '../constants/common';

const getDomainPrices = ({ priceData, currency, extraPrice, isSpecialOfferEnabled }) => {
  if (extraPrice === extraPrices.FREE_COM_DOMAIN && isSpecialOfferEnabled) {
    return {
      price: priceData['P1Y'].extra_prices.free_com_domain[currency],
      oldPrice: priceData['P1Y'].prices[currency],
    };
  }

  if (extraPrice === extraPrices.NO_DISCOUNTS && isSpecialOfferEnabled) {
    return {
      price: priceData['P1Y'].prices[currency],
      oldPrice: priceData['P1Y'].extra_prices.no_discounts[currency],
    };
  }

  return {
    price: priceData['P1Y'].prices[currency],
  };
};

export default getDomainPrices;
